"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSummary = void 0;
const react_1 = __importStar(require("react"));
const Feedback_1 = require("../../Feedback/Feedback");
const Text_1 = require("../../Text/Text");
const ErrorSummary_styles_1 = require("./ErrorSummary.styles");
const ErrorSummaryContext_1 = require("./ErrorSummaryContext");
const scrollToAndFocusElement = (element) => {
    element.scrollIntoView({ behavior: "smooth" });
    element.focus();
};
function ErrorSummary({ isShown = false, title = "There is a problem", }) {
    const { errors } = (0, ErrorSummaryContext_1.useErrorSummary)();
    const firstItemRef = (0, react_1.useRef)(null);
    (0, react_1.useLayoutEffect)(() => {
        if (errors.length > 0 && isShown) {
            if (!firstItemRef || !firstItemRef.current)
                return;
            scrollToAndFocusElement(firstItemRef.current);
        }
    }, [errors.length, isShown]);
    const handleScrollToInlineError = (e, id) => {
        e.preventDefault();
        const element = document.getElementById(id);
        if (!element)
            return;
        scrollToAndFocusElement(element);
    };
    return isShown ? (react_1.default.createElement("div", { role: "alert", "aria-labelledby": "error-summary-title" }, errors.length > 0 && isShown && (react_1.default.createElement(Feedback_1.Feedback, { colour: "error" },
        react_1.default.createElement(ErrorSummary_styles_1.StyledErrorHeader, null,
            react_1.default.createElement(Text_1.Text, { skinny: true, props: { id: "error-summary-title" }, variant: "label", as: "h2" }, title)),
        react_1.default.createElement(ErrorSummary_styles_1.StyledErrorList, null, errors.map((error, index) => (react_1.default.createElement(Text_1.Text, { key: error.id, as: "li" },
            react_1.default.createElement(ErrorSummary_styles_1.StyledErrorLink, { ref: index === 0 ? firstItemRef : null, href: `#${error.id}`, onClick: (e) => handleScrollToInlineError(e, error.id) }, error.body))))))))) : (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.ErrorSummary = ErrorSummary;
//# sourceMappingURL=ErrorSummary.js.map